export default __webpack_public_path__ + "static/media/like.b174ab2c.svg";